module.exports = __webpack_public_path__ + "media/images/prediction/special/nagai/img_photo_nagai-128628db0dd786ea8166f61a8de648f7.jpg";